module.exports = __webpack_public_path__ + "static/media/back6.d4c9c586.jpg";